import { useContext } from 'react';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { PersonDataContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';
import { inferBankCountryCode } from '@dealstack/frontend/shared/components/BankAccountForm/BankAccountForm.utils.ts';
import { getMainAddress } from '@dealstack/frontend/shared/address.ts';

/**
 * Binds the shared BankAccountDrawer to the entity this flow has selected. Spread onto the
 * drawer; every screen that opens one here is editing the same person.
 */
export const useCapBankAccountDrawerProps = (): {
	personId: string;
	inferredCountryCode?: string;
	onSaved: () => void;
} => {
	const { selectedEntityId, selectedEntityData } = useContext(CapManageControllerContext);
	const { refetchBankAccounts } = useContext(PersonDataContext);

	return {
		personId: selectedEntityId,
		inferredCountryCode: inferBankCountryCode(
			getMainAddress(selectedEntityData?.addresses)?.country
		),
		onSaved: refetchBankAccounts,
	};
};
